























import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import router from '../../router';
import { ITree } from '../store/dto/Organization';
import { KanriConstants } from '../fixed/KanriConstants';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class OrganizationTree extends ApiAccessBase {
  @Prop() value!: ITree;
  private active: any[] = [];
  private open: any[] = [];
  // 画面初期化処理
  // component生成時に実行
  private created() {
    // const result = this.apiAccess(KanriConstants.ORG_PATH + '/tree', Constants.API_METHOD_GET, false, true);
    this.apiAccess(KanriConstants.ORG_PATH + '/tree', Constants.API_METHOD_GET, false, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        this.open = this.resultData;
      }
    });
  }
  /**
   * ツリーのアイテムが選択されたときに発火
   */
  @Watch('active')
  private onChangeActive(newActive: any[], oldActive: any[]): void {
    if (newActive[0]) {
      this.value.szkCd = newActive[0]['szkCd'];
      this.value.naibCd = newActive[0]['naibCd'];
      this.value.level = String(Number(newActive[0]['level']) + 1);
      this.value.position = newActive[0]['position'];
    } else {
      this.value.szkCd = '';
      this.value.naibCd = '';
      this.value.level = '';
      this.value.position = '';
    }
  }
  @Emit('value')
  private selectValue(value: ITree) {
    return value;
  }
}
